import './DeleteAccount.css';

const DeleteAccount = () => {
  return (
    <div className="delete-account-container">
      <div className="delete-account-content">
        <h1>Account Data Deletion Request</h1>
        
        <div className="warning-box">
            <strong>Warning:</strong> Deleting your account is permanent. Once completed, you will lose access to all your saved recipes, meal plans, and grocery lists. This action cannot be undone.
        </div>

        <p>At <strong>Noon Solutions</strong>, we respect your privacy and your right to control your data. If you no longer wish to use the <strong>Chamcha (چمچة)</strong> app and want your account permanently deleted, please follow the instructions below.</p>

        <div className="instruction-box">
            <h3>How to request deletion:</h3>
            <p>1. Send an email to our support team using the email address associated with your Chamcha account.</p>
            <p>2. Use the subject line: <strong>"Account Deletion Request"</strong></p>
            <p>3. In the body of the email, simply state that you wish to have your account and all associated data permanently removed from our servers.</p>
            
            <a href="mailto:muntajabalani98@gmail.com?subject=Account%20Deletion%20Request&body=Hello,%20I%20would%20like%20to%20request%20the%20permanent%20deletion%20of%20my%20Chamcha%20account%20and%20all%20associated%20data%20linked%20to%20this%20email%20address." className="email-button">Click Here to Send Deletion Email</a>
        </div>

        <p className="note-text">
            <em>Note: We process all deletion requests within 14 business days. Upon completion, your email, profile picture, saved lists, and login credentials will be permanently erased from our active database.</em>
        </p>
      </div>
    </div>
  );
};

export default DeleteAccount;
